import { InlineAlert } from '../../components/BaseComponents'
import { useState } from "react";
import { LoadingSpinner } from "../../components/BaseComponents";
import ConfirmationModal from "../../components/BaseComponents/ConfirmationModal";
import useApi from "../../hooks/useApi";
import { getApiErrorMessage, getCSRFToken } from "../../lib/utils";

type DeleteTrainingSessionModalProps = {
    onClose: () => void,
    onDeleted: () => void,
    isOpen?: boolean,
    sessionId: string,
    sessionName: string,
};

function DeleteTrainingSessionModal({ onClose, onDeleted, isOpen, sessionId, sessionName }: DeleteTrainingSessionModalProps) {
    const api = useApi();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const deleteSession = async () => {
        setLoading(true);
        setError('');
        try {
            await api.delete(`/admin/training-sessions/${sessionId}`, {
                _csrf: await getCSRFToken(),
            })
            onDeleted();
        } catch (err: any) {
            // 409 = the session still has users assigned - blocked per Sprint 4's resolved
            // delete-semantics decision (docs/todo/admin-user-training-sessions.md)
            setError(getApiErrorMessage(err, 'Failed to delete this training session.'));
        } finally {
            setLoading(false);
        }
    }

    return (
        <ConfirmationModal open={!!isOpen} onCancel={onClose} onConfirm={deleteSession} title={`Delete training session ${sessionName}?`}>
            { loading && <LoadingSpinner /> }
            { error && (
                <InlineAlert type='error' className='mt-8'>{ error }
                </InlineAlert>
            )}
        </ConfirmationModal>
    )
}

export default DeleteTrainingSessionModal;
